import { render, staticRenderFns } from "./ConfirmQuestion.vue?vue&type=template&id=71c3dc6d"
import script from "./ConfirmQuestion.vue?vue&type=script&lang=js"
export * from "./ConfirmQuestion.vue?vue&type=script&lang=js"
import style0 from "./ConfirmQuestion.vue?vue&type=style&index=0&id=71c3dc6d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports